
<div
  class=""
>
<app-modal-header [title]="title" (closeModal)="closeModal($event)"></app-modal-header>

  <mat-dialog-content [formGroup]="approvalFlowForm">
    <div class="row">

      <div class="col-md-12">
        <mat-form-field appearance="outline" class="material-form w-100">
            <mat-label>Flow Process</mat-label>
            <mat-select formControlName="flowProcess">
              @if (from === 'POPSM') {
                <mat-option value="POPSMGG_SERVICE_APPROVAL">
                  POPSMGG SERVICE APPROVAL
                </mat-option>
              } @else {
                <mat-option value="SERVICE">
                  SERVICE
                </mat-option>
              }
            </mat-select>
            <mat-error>
                <span *ngIf="!approvalFlowForm.get('flowProcess').valid && approvalFlowForm.get('flowProcess').touched">
                    Field is required.
                </span>
            </mat-error>
        </mat-form-field>
    </div>
      <div class="col-md-12">
        <mat-form-field
          appearance="outline"
          class="material-form w-full rounded-3xl"
        >
          <mat-label>Flow Title</mat-label>
          <input
            formControlName="flowTitle"
            matInput
            placeholder="Flow Title"
            class=""
          />
          <mat-error>
            <span
              *ngIf="
                !approvalFlowForm.get('flowTitle').valid &&
                approvalFlowForm.get('flowTitle').touched
              "
            >
              Field is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-end mt-2">
          <button
            [disabled]="!approvalFlowForm?.valid"
            class="custom-button submit-btn" color="primary" mat-raised-button
            (click)="submitForm(approvalFlowForm.value)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
